import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeBlockedConversationsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeBlockedConversationsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeBlockedConversationsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeBlockedConversationsResponseDataSchema>
>

type Props = {
  query: Query
  onSuccess?: (data: Response) => void
}

export const getBackofficeBlockedConversationsQuery = ({ query, onSuccess }: Props) =>
  queryOptions({
    queryKey: ["backofficeWhatsappBlockedConversations", query],
    queryFn: async () => {
      const { data } = await axios.get<Response>(
        "/backoffice/whatsappRoutes/blockedConversations",
        {
          params: query,
        },
      )
      onSuccess?.(data)
      return data.data
    },
  })
